/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditReportsExecuteGipReportMutationRequest, AuditReportsExecuteGipReportMutationResponse, AuditReportsExecuteGipReportQueryParams, AuditReportsExecuteGipReport400, AuditReportsExecuteGipReport401, AuditReportsExecuteGipReport403, AuditReportsExecuteGipReport500 } from "../models/AuditReportsExecuteGipReport";

export function getAuditReportsExecuteGipReportUrl() {
  const res = { method: 'POST', url: `/audit-reports/v1/reports/gip/results` as const }
  return res
}

/**
 * @summary Generate report results
 * {@link /audit-reports/v1/reports/gip/results}
 */
export async function auditReportsExecuteGipReport(data: AuditReportsExecuteGipReportMutationRequest, params?: AuditReportsExecuteGipReportQueryParams, config: Partial<RequestConfig<AuditReportsExecuteGipReportMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<AuditReportsExecuteGipReportMutationResponse, ResponseErrorConfig<AuditReportsExecuteGipReport400 | AuditReportsExecuteGipReport401 | AuditReportsExecuteGipReport403 | AuditReportsExecuteGipReport500>, AuditReportsExecuteGipReportMutationRequest>({ method : "POST", url : getAuditReportsExecuteGipReportUrl().url.toString(), params, data : requestData, ... requestConfig })
  return res.data
}